import { Models } from "api/types";
import { PlatformLocation } from "molecules/platform-location/PlatformLocation";

interface PlatformLocationsListProps {
  platforms: Models<"GetMultiPlatformUserPlatformResult">[];
  onItemClick: (platform: Models<"GetMultiPlatformUserPlatformResult">) => void;
}

export const PlatformLocationsList = ({
  platforms,
  onItemClick,
}: PlatformLocationsListProps) => {
  if (!platforms.length) {
    return null;
  }

  return (
    <ul className="flex flex-col gap-2">
      {platforms.map((platform) => (
        <PlatformLocation
          key={platform.platformId}
          platform={platform}
          onClick={() => {
            onItemClick(platform);
          }}
        />
      ))}
    </ul>
  );
};
